(() => {
  if (window.designeriaEventsReady) return;
  window.designeriaEventsReady = true;
  const pendingVariants = new WeakMap();
  const updateCrossTotal = form => {
    const total = form.querySelector('[data-dg-cross-total]');
    if (!total) return;
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    if (!Number.isSafeInteger(quantity) || quantity < 1) { total.hidden = true; return; }
    const extras = [...form.querySelectorAll('[data-dg-bulb-variant]:checked:not(:disabled),[data-dg-extra-variant]:checked:not(:disabled)')];
    const price = (Number(total.dataset.base) + extras.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0)) * quantity;
    total.hidden = extras.length === 0;
    total.textContent = total.dataset.label + ': ' + new Intl.NumberFormat(document.documentElement.lang || 'de-AT', {style:'currency',currency:total.dataset.currency || 'EUR'}).format(price / 100);
  };
  document.addEventListener('input', event => {
    if (!(event.target instanceof Element)) return;
    const form = event.target.closest('.dg-product-form');
    if (form) updateCrossTotal(form);
  });

  const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const initGallery = root => {
    root.querySelectorAll('.dg-bulb-addon,[data-dg-cross-sell]').forEach(addon => { addon.hidden = false; });
    root.querySelectorAll('.dg-product-form').forEach(updateCrossTotal);
    root.querySelectorAll('[data-dg-variant-control]').forEach(control => { control.hidden = false; });
    root.querySelectorAll('.dg-gallery').forEach(gallery => {
      const track = gallery.querySelector('.dg-gallery-track');
      if (!track || track.dataset.ready) return;
      track.dataset.ready = 'true';
      const slides = [...track.children];
      const links = [...gallery.querySelectorAll('[data-dg-slide]')];
      let queued = false;
      track.addEventListener('scroll', () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          const axis = window.matchMedia('(min-width: 990px)').matches ? 'top' : 'left';
          const start = track.getBoundingClientRect()[axis];
          let selected = 0;
          slides.forEach((slide, index) => {
            if (Math.abs(slide.getBoundingClientRect()[axis] - start) < Math.abs(slides[selected].getBoundingClientRect()[axis] - start)) selected = index;
          });
          links.forEach((link, index) => index === selected ? link.setAttribute('aria-current', 'true') : link.removeAttribute('aria-current'));
        });
      }, {passive: true});
      const mediaId = gallery.closest('[data-dg-product]')?.dataset.featuredMedia;
      const selected = slides.find(slide => slide.id === `DesigneriaMedia-${mediaId}`);
      if (selected) {
        const vertical = window.matchMedia('(min-width: 990px)').matches;
        track.scrollTo({left: vertical ? 0 : selected.offsetLeft - slides[0].offsetLeft, top: vertical ? selected.offsetTop - slides[0].offsetTop : 0});
        links[slides.indexOf(selected)]?.setAttribute('aria-current', 'true');
      } else links[0]?.setAttribute('aria-current', 'true');
    });
  };
  const initMixes = root => root.querySelectorAll('[data-dg-mix]').forEach(mix => {
    if (mix.dataset.ready) return;
    mix.dataset.ready = 'true';
    const grid = mix.querySelector('[data-dg-mix-grid]');
    const original = [...grid.children];
    let cards = [...original];
    const size = Number(mix.dataset.pageSize) || 12;
    let visible = size;
    const more = mix.querySelector('[data-dg-more]');
    const status = mix.querySelector('[data-dg-mix-status]');
    const render = () => {
      cards.forEach((card, index) => { card.hidden = index >= visible; });
      more.hidden = visible >= cards.length;
      status.textContent = status.dataset.label.replace('[shown]', Math.min(visible, cards.length)).replace('[total]', cards.length);
    };
    mix.querySelectorAll('[data-dg-mix-controls]').forEach(control => { control.hidden = false; });
    mix.querySelector('[data-dg-mix-sort]').addEventListener('change', event => {
      const [field, direction] = event.target.value.split('-');
      cards = [...original];
      if (field !== 'featured') cards.sort((a, b) => {
        const comparison = field === 'title' ? a.dataset.dgTitle.localeCompare(b.dataset.dgTitle, document.documentElement.lang || 'de', {numeric: true}) : Number(a.dataset[field === 'price' ? 'dgPrice' : 'dgDate']) - Number(b.dataset[field === 'price' ? 'dgPrice' : 'dgDate']);
        return direction === 'descending' ? -comparison : comparison;
      });
      grid.replaceChildren(...cards);
      visible = size;
      render();
    });
    more.addEventListener('click', () => {
      const next = cards[visible]?.querySelector('a[href]');
      visible += size;
      render();
      next?.focus({preventScroll: true});
    });
    render();
  });
  const revealHash = () => {
    if (!location.hash) return;
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (!target) return;
    const detail = target.matches('details') ? target : target.closest('details');
    if (detail) {
      detail.open = true;
      requestAnimationFrame(() => target.scrollIntoView({block: 'start', behavior: 'auto'}));
    }
  };
  const initMobileMenus = root => root.querySelectorAll('.dg-mobile-menu').forEach(menu => {
    if (menu.dataset.dgPositionReady) return;
    menu.dataset.dgPositionReady = 'true';
    const header = menu.closest('.dg-header');
    const position = () => {
      if (!menu.isConnected || !menu.open || !header) return;
      menu.style.setProperty('--dg-mobile-menu-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    };
    menu.addEventListener('toggle', position);
    window.addEventListener('resize', position, {passive: true});
    window.addEventListener('scroll', position, {passive: true});
    position();
  });
  const initProportions = root => root.querySelectorAll('[data-proportion-tool]').forEach(tool => {
    if (tool.dataset.dgValidationReady) return;
    const inputs = [...tool.querySelectorAll('#dp-height, #dp-width')];
    const illustration = tool.querySelector('.dp-illustration');
    if (inputs.length !== 2 || !illustration) return;
    tool.dataset.dgValidationReady = 'true';
    const error = document.createElement('p');
    error.id = 'DgProportionsError';
    error.className = 'dg-proportions-error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    tool.prepend(error);
    const validate = () => {
      let invalid = false;
      for (const input of inputs) {
        const valid = Number.isFinite(input.valueAsNumber) && input.validity.valid;
        input.setAttribute('aria-invalid', String(!valid));
        const describedBy = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        if (valid) describedBy.delete(error.id); else describedBy.add(error.id);
        if (describedBy.size) input.setAttribute('aria-describedby', [...describedBy].join(' '));
        else input.removeAttribute('aria-describedby');
        invalid ||= !valid;
      }
      error.textContent = invalid ? tool.closest('[data-dg-proportion-error]').dataset.dgProportionError : '';
      error.hidden = !invalid;
      tool.toggleAttribute('data-dg-invalid', invalid);
      illustration.hidden = invalid;
    };
    tool.addEventListener('input', validate);
    tool.addEventListener('change', validate);
    validate();
  });
  const initPriceRanges = root => root.querySelectorAll('[data-dg-filter-form]').forEach(form => {
    if (form.dataset.dgValidationReady) return;
    const min = form.querySelector('[data-dg-price-min]');
    const max = form.querySelector('[data-dg-price-max]');
    if (!min || !max) return;
    form.dataset.dgValidationReady = 'true';
    const validate = () => {
      const invalid = min.value !== '' && max.value !== '' && min.valueAsNumber > max.valueAsNumber;
      max.setCustomValidity(invalid ? max.dataset.rangeError : '');
    };
    form.addEventListener('input', validate);
    validate();
  });

  const init = root => { initGallery(root); initMixes(root); initMobileMenus(root); initProportions(root); initPriceRanges(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { init(document); revealHash(); });
  else { init(document); revealHash(); }
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('hashchange', revealHash);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-dg-slide]');
    if (!link) return;
    const gallery = link.closest('.dg-gallery');
    const track = gallery.querySelector('.dg-gallery-track');
    const slide = [...track.children].find(item => `#${item.id}` === link.hash);
    if (!slide) return;
    event.preventDefault();
    const vertical = window.matchMedia('(min-width: 990px)').matches;
    track.scrollTo({left: vertical ? 0 : slide.offsetLeft - track.children[0].offsetLeft, top: vertical ? slide.offsetTop - track.children[0].offsetTop : 0, behavior: motion()});
  });
  document.addEventListener('change', async event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-dg-variant]')) return;
    const root = select.closest('[data-dg-product]');
    if (!root) return;
    pendingVariants.get(root)?.abort();
    const controller = new AbortController();
    pendingVariants.set(root, controller);
    const chosen = select.value;
    const url = new URL(root.dataset.productUrl, location.origin);
    const current = new URL(location.href);
    for (const key of ['preview_theme_id', '_fd', 'pb']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    url.searchParams.set('variant', chosen);
    const sectionUrl = new URL(url);
    sectionUrl.searchParams.set('section_id', root.dataset.sectionId);
    root.setAttribute('aria-busy', 'true');
    root.querySelectorAll('.dg-buy-button,.dg-sticky-buy button').forEach(button => { button.disabled = true; });
    const status = root.querySelector('[data-dg-variant-status]');
    if (status) status.textContent = status.dataset.loading;
    const quantity = root.querySelector('.dg-product-form input[name="quantity"]')?.value;
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(sectionUrl, {signal: controller.signal, credentials: 'same-origin'});
      if (!response.ok) throw new Error('Variant unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.querySelector('[data-dg-product]');
      if (!fresh || fresh.dataset.variantId !== chosen) throw new Error('Variant mismatch');
      if (pendingVariants.get(root) !== controller || !root.isConnected) return;
      const nextQuantity = fresh.querySelector('.dg-product-form input[name="quantity"]');
      if (nextQuantity && quantity) nextQuantity.value = quantity;
      root.replaceWith(fresh);
      init(document);
      history.replaceState({}, '', url);
      fresh.querySelector('[data-dg-variant]')?.focus({preventScroll: true});
    } catch {
      if (pendingVariants.get(root) === controller && root.isConnected) location.assign(url);
    } finally {
      clearTimeout(timeout);
    }
  });
  document.addEventListener('keydown', event => {
    const menu = document.querySelector('.dg-mobile-menu[open]');
    if (!menu) return;
    if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); return; }
    if (event.key !== 'Tab') return;
    const controls = [...menu.querySelectorAll('summary, a[href], button, input, select, textarea, [tabindex]')].filter(el => el.tabIndex >= 0 && !el.disabled && el.getClientRects().length);
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('toggle', event => {
    if (event.target instanceof Element && event.target.matches('.dg-mobile-menu')) {
      document.documentElement.classList.toggle('dg-menu-open', event.target.open);
      event.target.querySelector('summary').setAttribute('aria-expanded', String(event.target.open));
    }
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.dg-product-form')) return;
    const addon = form.querySelector('[data-dg-cross-sell]') || form.querySelector('.dg-bulb-addon');
    const extras = [...form.querySelectorAll('[data-dg-bulb-variant]:checked:not(:disabled),[data-dg-extra-variant]:checked:not(:disabled)')];
    if (!extras.length) return;
    event.preventDefault();
    if (form.dataset.cartPending === 'true') return;
    const data = new FormData(form);
    const id = data.get('id');
    const quantity = Number(data.get('quantity') || 1);
    const error = addon.querySelector('[data-dg-cart-error]');
    const errorText = addon.querySelector('[data-dg-cart-error-text]');
    if (!id || !Number.isSafeInteger(quantity) || quantity < 1) return;
    const item = {id, quantity};
    const properties = {};
    for (const [key, value] of data) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string') properties[match[1]] = value;
    }
    if (Object.keys(properties).length) item.properties = properties;
    if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
    const controls = [...form.elements].filter(control => 'disabled' in control);
    const disabled = controls.map(control => control.disabled);
    form.dataset.cartPending = 'true';
    form.setAttribute('aria-busy', 'true');
    controls.forEach(control => { control.disabled = true; });
    error.hidden = true;
    try {
      const endpoint = new URL(form.action, location.origin);
      endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
      const response = await fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: [item, ...[...new Set(extras.map(input => input.value))].map(id => ({id, quantity}))]})
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : (addon.dataset.addError || addon.dataset.error));
      location.assign(addon.dataset.cartUrl);
    } catch (reason) {
      errorText.textContent = reason instanceof Error && reason.message !== 'Failed to fetch' ? reason.message : addon.dataset.addError;
      error.hidden = false;
      controls.forEach((control, index) => { control.disabled = disabled[index]; });
      delete form.dataset.cartPending;
      form.removeAttribute('aria-busy');
    }
  });
  window.matchMedia('(min-width: 990px)').addEventListener('change', event => {
    if (event.matches) document.querySelectorAll('.dg-mobile-menu[open]').forEach(menu => { menu.open = false; });
  });
})();


